import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { CustomJrpcErrResult } from '../general/modules/jsonRpc/jRpcErrResponse';
import { GetLinkedAccountsInfoRequest, GetLinkedAccountsInfoResponse } from './tethers-types';
import { container } from '../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../utils/container/service-ids';
import { FlagNames } from '../utils/feature-flags/flag-names';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export class Tethers {
    public static async getLinkedAccountsInfo(suid:string, token: string): Promise<
        GetLinkedAccountsInfoResponse|CustomJrpcErrResult
    > {
        const request: GetLinkedAccountsInfoRequest = {
            suid,
            token
        };
        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

        if (!isHubApiEnabled) {
            return await HubJsonRpcRequest.makeRequest<
                GetLinkedAccountsInfoResponse,
                GetLinkedAccountsInfoRequest
            >(HubApiMethods.GET_LINKED_ACCOUNTS_INFO, request, window.app.deviceIdentifier);
        } else {
            const hubApi = getHubApi();
            return await hubApi.getLinkedAccountsInfo(window.app.deviceIdentifier, request);
        }
    }
}
